import React from 'react';

export default function WhyJoinTissa() {
  return (
     <div className="bg-white rounded-lg shadow p-6 text-center">
      {/* Section Title */}
      <h2 className="text-2xl font-bold text-gray-800 mb-6">
        Why Join STISSA Technology LLP (TISSA Technology)?
      </h2>

      {/* Features Grid */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6 text-left mb-8">
        {/* Feature 1 */}
        <div className="p-4">
          <h3 className="text-lg font-semibold text-primary mb-2">
            Innovative Projects
          </h3>
          <p className="text-gray-700">
            Work on cutting-edge technologies and challenging projects for
            Fortune 500 clients.
          </p>
        </div>

        {/* Feature 2 */}
        <div className="p-4">
          <h3 className="text-lg font-semibold text-primary mb-2">
            Growth Opportunities
          </h3>
          <p className="text-gray-700">
            Continuous learning and career advancement paths for ambitious
            professionals.
          </p>
        </div>

        {/* Feature 3 */}
        <div className="p-4">
          <h3 className="text-lg font-semibold text-primary mb-2">
            Collaborative Culture
          </h3>
          <p className="text-gray-700">
            Join a team that values collaboration, creativity, and technical
            excellence.
          </p>
        </div>
      </div>

      {/* Closing Statement */}
      <p className="text-gray-700 max-w-2xl mx-auto">
        We’re looking for talented individuals who are passionate about
        technology and ready to make an impact. If you’re driven, innovative,
        and eager to grow, we want to hear from you!
      </p>
    </div>
  );
}
